import Button from "@app/sharedComponents/Button/Button";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { ScrollView,Image } from "react-native";
import AccordionListItem from "../ConfirmPay/components/AccordionAnimated";
import { Info } from '@app/sharedComponents/Icons/Icons';
import { useEffect, useState } from "react";
import { endpoints } from "@app/api/apis";
import { useAppSelector } from "@app/store/hooks";
import axios from "axios";
import dayjs from "dayjs";
import DashedLine from "@app/sharedComponents/DashedLine/DashedLine";
import BankTransferDetails from "../ConfirmPay/components/BankTransferDetails";
import { checkColor, REPAYMENT_COLLECTION_TYPE } from "@app/utils";
import {RadioButton,Circle, WarningCircle} from '@app/sharedComponents/Icons/Icons';
import useFetchForeclosureDetails from "@app/hooks/useFetchForeclosureDetails";
import PageLoader from "@app/sharedComponents/PageLoader/PageLoader";


const RepayDues = ({navigation})=>{
    const userDetails = useAppSelector((state) => state?.auth?.userDetails);
    const userProfile = useAppSelector((state) => state.auth.userProfile);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('BANK_TRANSFER');
    const [bankTransferDetails,setBankTransferDetails] = useState({});

    const renewalDate = dayjs(userDetails?.linkedCredits[0]?.renewalDate)
    const currentDate = dayjs()
    const isLoanExpired = renewalDate.isBefore(currentDate) ;

    const {fetchForeclosureDetailsLoading,foreClosureData} = useFetchForeclosureDetails();
    const netPayable = foreClosureData?.netPayable;
    const {outstandingCharges,totalNotionalChargesAndDematBounce,advanceInterest,penalInterestAccruedNotDue,outstandingInterest,interestAccruedNotDue,nextDayInterestChargeDue,penalInterest,outstandingPrincipal} = foreClosureData || {};

    const totalOutstandingCharges = (outstandingCharges || 0) + (penalInterest || 0) + (penalInterestAccruedNotDue || 0) + (totalNotionalChargesAndDematBounce || 0);
    const totalOutstandingInterest = (outstandingInterest || 0 ) + (interestAccruedNotDue|| 0) + (nextDayInterestChargeDue || 0);

    const headerTitle = () => {
        let title = '';
        if(!isLoanExpired){
            title = 'Foreclose your loan';
        }
        else if(netPayable >= 0){
            title = 'Pay outstanding dues'
        }
        else title = 'Get refund'
        return title;
    }

    const paymentModeSelected = (mode: string) => {
        if(selectedPaymentMethod === 'BANK_TRANSFER'){
            setSelectedPaymentMethod('');
        }
        else setSelectedPaymentMethod(mode);
    }

    const fetchBankTransferDetails = ()=>{
        const url = endpoints.bankTransferDetails + userDetails?.linkedCredits[0]?.creditId
        axios.get(url).then((res)=>{
            setBankTransferDetails(res?.data?.principleRepaymentBankAccountDetails)
        })
        .catch((err)=>{
            console.log('bankTransferDetails',err)
        })
    }

    useEffect(()=>{
        fetchBankTransferDetails();
    },[]);


    return(
        fetchForeclosureDetailsLoading ? <PageLoader/> :
        <>
        <PageHeaders label={headerTitle()} pageName="RepayDues" navigation={navigation}/>
        <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-page"]}}>
        <ThemedView m="lg" mb="sm" flexDirection="row" alignItems="center" px='md' py="sm" borderWidth={1} borderColor="border-primary" borderRadius="sm" backgroundColor="bg-surface-primary" >
            <Image 
                source={{
                    uri:`https://volt-images-alpha.s3.ap-south-1.amazonaws.com/outstanding_icon.png`}} 
                    style={{width:46,height:46}}/>
            <ThemedView ml="md" style={{flexShrink:1}}>
                <ThemedText variant="b3s" color="text-primary" >{netPayable>0 ? 'You have outstanding dues':'You have excess amount'}</ThemedText>
                <ThemedText variant="b4r" color="text-secondary" >{netPayable>0 ?'Foreclosure can be raised once the outstanding balance is cleared':'Place refund request to proceed'}</ThemedText>
            </ThemedView>
        </ThemedView>
        <ThemedView mx="lg" my="lg" borderWidth={1} borderColor="border-primary" borderRadius="sm" pt="lg">
                <ThemedView px="md" flexDirection="row" alignItems="center" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">Total amount</ThemedText>
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant="l2"  color={netPayable >=0 ? "text-primary" : 'text-emphasis-secondary'}>{netPayable >= 0 ? '₹' : '-₹'}</ThemedText>
                        <ThemedText variant="h2s" color={netPayable >=0 ? "text-primary" : 'text-emphasis-secondary'}>{formatIndianCurrency(Math.abs(netPayable))}</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView mt="lg" px="md">
                    <DashedLine />
                </ThemedView>
                <ThemedView  backgroundColor="bg-surface-primary" borderBottomLeftRadius="sm" borderBottomRightRadius="sm">
                    <AccordionListItem
                        title={'Charges due'}
                        subTitle={`${totalOutstandingCharges < 0 ? '-':''}₹${formatIndianCurrency(Math.abs(totalOutstandingCharges))}`}
                        subTitleColor={totalOutstandingCharges < 0 ? "text-emphasis-secondary" : "text-primary"}
                    >
                        <ThemedView py="lg">
                            <ThemedView flexDirection="row" justifyContent="space-between" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Outstanding charges
                                </ThemedText>
                                <ThemedText 
                                    variant="b4r" 
                                    color={outstandingCharges < 0 ? "text-emphasis-secondary" : "text-primary"}
                                >
                                    {outstandingCharges<0 && '-'}₹{formatIndianCurrency(Math.abs(outstandingCharges) || 0)}
                                </ThemedText>
                            </ThemedView>
                            <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Total Demat and bounce charged
                                </ThemedText>
                                <ThemedText 
                                    variant="b4r"
                                    color={totalNotionalChargesAndDematBounce < 0 ? "text-emphasis-secondary" : "text-primary"}>
                                    {totalNotionalChargesAndDematBounce<0 && '-'}₹{formatIndianCurrency(Math.abs(totalNotionalChargesAndDematBounce) || 0)}
                                </ThemedText>
                            </ThemedView>
                            <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Penal charges accrued not due
                                </ThemedText>
                                <ThemedText 
                                    variant="b4r"
                                    color={penalInterestAccruedNotDue < 0 ? "text-emphasis-secondary" : "text-primary"}
                                >
                                    {penalInterestAccruedNotDue<0 && '-'}₹{formatIndianCurrency(Math.abs(penalInterestAccruedNotDue) || 0)}
                                </ThemedText>
                            </ThemedView>
                        </ThemedView>
                    </AccordionListItem>
                    <AccordionListItem
                        title={'Interest due'}
                        subTitle={`${totalOutstandingInterest < 0 ? '-':''}₹${formatIndianCurrency(Math.abs(totalOutstandingInterest))}`}
                        subTitleColor={totalOutstandingInterest < 0 ? "text-emphasis-secondary" : "text-primary"}
                    >
                        <ThemedView py="lg">
                            <ThemedView flexDirection="row" justifyContent="space-between" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Outstanding Interest
                                </ThemedText>
                                <ThemedText 
                                    variant="b4r"
                                    color={outstandingInterest < 0 ? "text-emphasis-secondary" : "text-primary"}
                                >
                                {outstandingInterest<0 && '-'}₹{formatIndianCurrency(Math.abs(outstandingInterest) || 0)}
                                </ThemedText>
                            </ThemedView>
                            <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Interest accrued not due
                                </ThemedText>
                                <ThemedText
                                    variant="b4r" 
                                    color={interestAccruedNotDue < 0 ? "text-emphasis-secondary" : "text-primary"}
                                >
                            {interestAccruedNotDue<0 && '-'}₹{formatIndianCurrency(Math.abs(interestAccruedNotDue) || 0)}
                                </ThemedText>
                            </ThemedView>
                            <ThemedView flexDirection="row" justifyContent="space-between" pt="sm" px="lg">
                                <ThemedText variant="b4r" color="text-primary">
                                    Advance interest
                                </ThemedText>
                                <ThemedText
                                    variant="b4r"
                                    color="text-emphasis-secondary"
                                >
                                {advanceInterest<0 && '-'}₹{formatIndianCurrency(Math.abs(advanceInterest) || 0)}
                                </ThemedText>
                            </ThemedView>
                        </ThemedView>
                    </AccordionListItem>
                    <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center' px="lg" my="lg">
                        <ThemedView flexDirection='row' alignItems='center'>
                            <ThemedText variant='b4s' color='text-primary' >Outstanding amount</ThemedText>
                        </ThemedView>
                        <ThemedText variant='b4s' color={outstandingPrincipal < 0 ? "text-emphasis-secondary" : "text-primary"} >
                            {outstandingPrincipal<0 && '-'}₹{formatIndianCurrency(Math.abs(outstandingPrincipal) || 0)}
                        </ThemedText>
                    </ThemedView>
                </ThemedView>
        </ThemedView>
        <ThemedView mx="lg" mb="lg" p="md" borderRadius="sm" flexDirection="row"  justifyContent="center" flex={1} borderColor="border-warning" borderWidth={1} backgroundColor="bg-fill-warning" >
            <Info size={16} weight="fill"  color="#f9bd21" style={{marginTop:2}}/>
            <ThemedView flexDirection="row" flex={1} flexWrap="wrap" ml="sm">
                <ThemedText variant="b4r" color="text-primary">
                    Repay the total due via bank transfer.
                </ThemedText>
                <ThemedText variant="b3s" color="text-primary">
                     Note:{' '}
                     <ThemedText variant="b4r" color="text-primary">
                        Payments can take upto 24 hrs to reflect on loan account.
                     </ThemedText>
                </ThemedText>
            </ThemedView>
        </ThemedView>
        <ThemedView p='md' mx='lg' mb='lg' borderWidth={1} borderColor="border-primary" borderRadius="sm"  backgroundColor="bg-surface-primary">
            <ThemedText variant="h6s" color="text-primary">
                Transfer funds
            </ThemedText>
            <ThemedView mt='md' borderTopColor="border-primary" borderTopWidth={1}>
                <ThemedPressable my="lg"  flexDirection="row" alignItems="center" justifyContent="space-between" onPress={()=>paymentModeSelected('BANK_TRANSFER')}>
                    <ThemedView flexDirection="row" alignItems="center"> 
                    <Image 
                    source={{
                        uri:`https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Bank+Transfer.png`}} 
                        style={{width:46,height:46}}
                    />
                    <ThemedView ml="sm">
                        <ThemedText variant="h6s" color="text-primary" mb='xs'>
                        Bank transfer
                        </ThemedText>
                        <ThemedText variant="b4r" color="text-secondary">
                        Via NEFT, RTGS, IMPS
                        </ThemedText>
                    </ThemedView>
                    </ThemedView>
                    {
                    selectedPaymentMethod === 'BANK_TRANSFER' ?
                    <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                    <Circle size={24}  color="#C0D1E7"/>
                }
                </ThemedPressable>
            {
                selectedPaymentMethod === 'BANK_TRANSFER' &&
                <BankTransferDetails bankTransferDetails={bankTransferDetails} userName={userProfile?.name}/>
            }
            </ThemedView>
        </ThemedView>
        </ScrollView>
        </>
    )
}
export default RepayDues;